import { spaceToZone } from 'utilities/date/formatDate';
import { toInteger } from 'lodash';

export const convert24ToAmPm = (time24) => {
  // Split the input time (in HH:MM format) into hours and minutes
  // eslint-disable-next-line prefer-const
  let [hours, minutes] = time24.split(':').map(Number);

  // Determine if it's AM or PM
  const period = hours >= 12 ? 'PM' : 'AM';

  // Convert 24-hour format to 12-hour format
  hours = hours % 12 || 12; // If the hour is 0 or 12, display it as 12 in 12-hour format

  // Return the formatted time with AM/PM
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${period}`;
};

export const parseTimeString = (s, return24hours = true) => {
  const pattern = /[\d]+|[\w]{2}/g;
  const matches = s.match(pattern);
  if (!matches) {
    return [0, 0];
  }
  const hours = matches[0];
  const minutes = matches[1];
  let h = toInteger(hours);
  const m = toInteger(minutes);
  if (return24hours) {
    const ampm = matches.length === 4 ? matches[3] : 'AM';
    h = ampm.toLowerCase() === 'pm' ? h + 12 : h;
  }
  return [h, m];
};

export const normalizeTime24 = (hours, minutes) => {
  let h = hours;
  let m = minutes;
  if (minutes > 59) {
    m = minutes % 60;
    h += Math.floor(minutes / 60);
  }
  if (h > 23) {
    h %= 24;
  }
  return [h, m];
};

export const convert24to12 = (hours, minutes) => {
  const d = new Date(1975, 1, 1, hours, minutes, 0);
  const timeString = d.toLocaleTimeString(undefined, { hourCycle: 'h12' });
  const [h, m] = parseTimeString(timeString, false);
  return [h, m];
};

export const convertHoursMinutesHMM = (hours, minutes) => `${hours.toString()}:${minutes < 10 ? '0' : ''}${minutes.toString()}`;

// returns time in minutes formatted as: x hrs x min
export const convertMinutes = (mins) => {
  const hours = Math.floor(mins / 60);
  const rHours = Math.floor(hours);
  const minutes = mins % 60;
  const rMinutes = Math.round(minutes);
  if (rHours === 0) {
    return `${rMinutes} min`;
  }
  if (rMinutes === 0) {
    return `${rHours} hrs`;
  }
  return `${rHours} hrs ${rMinutes} min`;
};

export const convertMinutesHMM = (minutes) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return convertHoursMinutesHMM(h, m);
};

export const isoTzToHHMMaa = (iso, tz) => spaceToZone(iso, tz).time();
export const convertHoursMinutesHHMM = (hours, minutes) => `${hours < 10 ? '0' : ''}${hours.toString()}:${minutes < 10 ? '0' : ''}${minutes.toString()}`;

export const hoursToMinutes = (hours) => hours * 60;
